import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import HpContactInfo from '../json-pages/HpContactInfo';
import HpFacilities from '../json-pages/HpFacilities';
import HpInformation from '../json-pages/HpInformation';
import HpLocation from '../json-pages/HpLocation';
import HpPrimaryDialog from '../json-pages/HpPrimaryDialog';

const UI = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Route path={`${match.url}/contact-info`} component={HpContactInfo} />
      <Route path={`${match.url}/facilities`} component={HpFacilities} />
      <Route path={`${match.url}/information`} component={HpInformation} />
      <Route path={`${match.url}/location`} component={HpLocation} />
      <Route path={`${match.url}/primary`} component={HpPrimaryDialog} />
      <Redirect to="/error" />
    </Switch>
  </div>
);
export default UI;
